export const SingleChatCreated = 'SingleChatCreated'
export const GroupChatCreated = 'GroupChatCreated'
export const ChatEditedEvent = 'ChatEdited'
export const ChatDeletedEvent = 'ChatDeleted'
export const ChatNewMessageEvent = 'ChatNewMessage'
export const ChatMemberAddedEvent = 'ChatMemberAdded'
export const ChatMemberRemovedEvent = 'ChatMemberRemoved'
export const ChatMessageCounterUpdatedEvent = 'ChatMessageCounterUpdated'
export const ChatAddedMessage = 'ChatAddedMessage'